import { graphql, useFragment } from 'react-relay';
import { useSurveyCardFragmentQuery_surveyRef$key } from './__generated__/useSurveyCardFragmentQuery_surveyRef.graphql';

const fragment = graphql`
  fragment useSurveyCardFragmentQuery_surveyRef on Survey {
    id
    iconUrl
    rewardAmount {
      formatted
      subUnitAmount
      currency
    }
    baseReward {
      cents
      currency
      formatted
    }
    lockedInfo {
      title
    }
    title
    url
    status
    supportId
    durationDetails {
      providerDuration
    }
    tags
    studyId
    adminData {
      rankScore
      surveyGuid
    }
  }
`;

export function useSurveyCardFragmentQuery(surveyRef: useSurveyCardFragmentQuery_surveyRef$key) {
  return useFragment<useSurveyCardFragmentQuery_surveyRef$key>(fragment, surveyRef);
}
